<template>
  <footer class="footer-main">
    <p class="mb-0">&copy; ITFA - {{$t('allRightsReserved')}}</p>
    <b-button @click="toTop" id="btnToTop">
      <img src="../../assets/images/up-arrow.png" alt="Boton arriba">
    </b-button>
  </footer>
</template>
<script>
export default {
  data () {
    return {
      intervalId: null
    }
  },
  methods: {
    toTop () {
      const _self = this
      this.intervalId = setInterval(() => {
        _self.scrollStep()
      }, 16.66)
    },
    scrollStep() {
      const main = document.getElementById('main')
      const currentPosY = main.scrollTop
      if (currentPosY < 30) {
          clearInterval(this.intervalId);
      }
      main.scroll(0, main.scrollTop - 50);
    }
  }
}
</script>
